import { isAxiosCancel } from '@/utilities/CancelSource.js';

export default {
    'ActivityTemplates/CONTENT_PAGES': {
        fields: ['pages'],
        callback: (store, mutation) => {
            const activity = store.getters['ActivityTemplates/get'](mutation.payload.uuid);

            if (!activity || !activity.activity_type || !activity.title) return;

            store.dispatch('AutoSave/setSaving', mutation);

            store
                .dispatch('AutoSave/activities', {
                    mutation: mutation.type,
                    activity,
                })
                .then(() => {
                    store.dispatch('AutoSave/setSaved', mutation);
                })
                .catch(err => {
                    if (!isAxiosCancel(err)) {
                        throw err;
                    }
                });
        },
    },
};
